// extracted by mini-css-extract-plugin
module.exports = {"container":"loder_container__1-Pwh","screen":"loder_screen__VzoQS","comparativeloader":"loder_comparativeloader__V6L43"};